import { identity, pick } from 'ramda'
import { mapProps } from 'recompose'
import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

export function Link(props) {
  const { children, disabled, onClick = identity } = props
  const style = { pointerEvents: disabled ? 'none' : 'auto' }
  const handleClick = e => disabled ? e.preventDefault() : onClick(e)

  return (
    <RouterLink {...props} style={style} onClick={handleClick}>
      {children}
    </RouterLink>
  )
}

const whitelist = pick(['children', 'disabled', 'replace', 'to'])

export default mapProps(whitelist)(Link)



// WEBPACK FOOTER //
// ./client/modules/ui/components/Link/index.js